/* 321 Cookie - design feedback widget (thumbs up/down + 3 quick reasons)
   Theme ASSET, loaded from the designer block with:
       <script src="{{ 'cookie-feedback.js' | asset_url }}" defer></script>
   Mount point, once, under the big design preview:  <div id="cd-feedback"></div>

   09-30 rewrite: one tap records the vote, shows "Thanks" and LOCKS the choice
   for that design (coming back to it from the tray shows the locked state).
   Thumbs-down offers three optional reason chips, no free-text box.
   Posts to https://stamp-ai-backend.vercel.app/api/feedback:
     {design_id, verdict:1|-1, session_id, attempt_number}   <- on the tap
     {design_id, reasons:[tag,...], session_id}              <- on a chip tap
   Chip tags (all in the backend feedback_tags table): likeness, too_plain, other.
   Contains NO Liquid. The stylesheet is injected from here.
*/
(function () {
  "use strict";
  var CSS = `
  .cd-fb { margin: 0; padding-top: 8px; font-size: 14px;
           border-top: 1px dashed var(--cd-line2, rgba(128,128,128,.3)); }
  .cd-fb-row { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
  .cd-fb-q { font-size: 14px; font-weight: 600; color: var(--cd-ink, inherit); margin-right: auto; }
  .cd-fb-btn {
    cursor: pointer; border: 1px solid var(--cd-line2, rgba(128,128,128,.45));
    background: var(--cd-surface, transparent); border-radius: 999px;
    min-width: 48px; min-height: 44px; padding: 0 14px; font: inherit; font-size: 20px; line-height: 1;
    opacity: .85; transition: opacity .15s, border-color .15s;
    touch-action: manipulation; -webkit-tap-highlight-color: transparent;
  }
  .cd-fb-btn:hover { opacity: 1; border-color: var(--cd-accent, currentColor); }
  .cd-fb-btn.is-on { opacity: 1; border-color: var(--cd-accent, currentColor);
                     background: var(--cd-accent-soft, rgba(128,128,128,.15)); }
  .cd-fb.is-locked .cd-fb-btn:not(.is-on) { opacity: .3; }
  .cd-fb.is-locked .cd-fb-btn { cursor: default; }
  .cd-fb-thanks { color: var(--cd-ok, inherit); font-size: 13px; font-weight: 600; margin-top: 6px; }
  .cd-fb-why { margin-top: 6px; }
  .cd-fb-whyq { font-size: 12px; color: var(--cd-muted, inherit); margin: 0 0 5px; }
  .cd-fb-chips { display: flex; flex-wrap: wrap; gap: 6px; }
  .cd-fb-chip {
    cursor: pointer; border: 1px solid var(--cd-line2, rgba(128,128,128,.45));
    background: var(--cd-surface, transparent); border-radius: 999px;
    min-height: 40px; padding: 0 13px; font: inherit; font-size: 13px; color: inherit;
    touch-action: manipulation;
  }
  .cd-fb-chip:hover { border-color: var(--cd-accent, currentColor); }
  .cd-fb-chip.is-on { font-weight: 600; border-color: var(--cd-accent, currentColor);
                      background: var(--cd-accent-soft, rgba(128,128,128,.15)); }
`;
  try {
    if (!document.getElementById("cd-fb-css")) {
      var s = document.createElement("style");
      s.id = "cd-fb-css";
      s.textContent = CSS;
      document.head.appendChild(s);
    }
  } catch (e) {}
})();

(function () {
  "use strict";

  var ENDPOINT = "https://stamp-ai-backend.vercel.app/api/feedback";

  /* Fixed three chips (Mike 09-30). Tags exist in the backend feedback_tags table. */
  var REASONS = [
    { tag: "likeness",  label: "Doesn’t look like them" },
    { tag: "too_plain", label: "Too simple" },
    { tag: "other",     label: "Something’s wrong with it" }
  ];

  var votes = {};      // design_id -> 1 | -1   (locked once set)
  var picked = {};     // design_id -> {tag: true}
  var mount = null;

  try {
    var saved = JSON.parse(sessionStorage.getItem("cdFbVotes") || "{}");
    if (saved && typeof saved === "object") votes = saved;
  } catch (e) {}
  function persist() {
    try { sessionStorage.setItem("cdFbVotes", JSON.stringify(votes)); } catch (e) {}
  }

  function post(payload) {
    try {
      payload.session_id =
        (window.CookieAnalytics && window.CookieAnalytics.sessionId) || null;
      fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        keepalive: true   /* a vote survives the customer closing the tab */
      }).catch(function () {});
    } catch (e) {}
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function render(designId) {
    if (!mount) return;
    mount.innerHTML = "";
    if (!designId) return;

    var wrap = el("div", "cd-fb");
    var row = el("div", "cd-fb-row");
    row.appendChild(el("span", "cd-fb-q", "How’s this one?"));
    var up = el("button", "cd-fb-btn", "\u{1F44D}");
    var down = el("button", "cd-fb-btn", "\u{1F44E}");
    up.type = down.type = "button";
    up.setAttribute("aria-label", "Good design");
    down.setAttribute("aria-label", "Not right");
    row.appendChild(up);
    row.appendChild(down);
    wrap.appendChild(row);
    mount.appendChild(wrap);

    var live = el("div", "cd-fb-thanks");
    live.setAttribute("role", "status");
    live.setAttribute("aria-live", "polite");
    wrap.appendChild(live);

    var why = null;

    function lock(v) {
      wrap.classList.add("is-locked");
      up.classList.toggle("is-on", v === 1);
      down.classList.toggle("is-on", v === -1);
      up.setAttribute("aria-disabled", "true");
      down.setAttribute("aria-disabled", "true");
      live.textContent = "Thanks!";
      if (v === -1 && !why) buildWhy();
    }

    function buildWhy() {
      why = el("div", "cd-fb-why");
      why.appendChild(el("p", "cd-fb-whyq", "What was off? (optional)"));
      var chips = el("div", "cd-fb-chips");
      var mine = picked[designId] = picked[designId] || {};
      REASONS.forEach(function (r) {
        var b = el("button", "cd-fb-chip", r.label);
        b.type = "button";
        if (mine[r.tag]) b.classList.add("is-on");
        b.addEventListener("click", function () {
          mine[r.tag] = !mine[r.tag];
          b.classList.toggle("is-on", !!mine[r.tag]);
          var reasons = Object.keys(mine).filter(function (k) { return mine[k]; });
          if (reasons.length) {
            post({ design_id: designId, reasons: reasons });
            live.textContent = "Thanks, that helps!";
          }
        });
        chips.appendChild(b);
      });
      why.appendChild(chips);
      wrap.appendChild(why);
    }

    function vote(v) {
      if (votes[designId]) return;          /* locked */
      votes[designId] = v;
      persist();
      post({
        design_id: designId,
        verdict: v,
        attempt_number:
          (window.CookieAnalytics && window.CookieAnalytics.attemptNumber &&
           window.CookieAnalytics.attemptNumber()) || null
      });
      lock(v);
    }

    up.addEventListener("click", function () { vote(1); });
    down.addEventListener("click", function () { vote(-1); });

    if (votes[designId]) lock(votes[designId]);
  }

  window.CookieFeedback = {
    attach: function (designId) {
      mount = mount || document.getElementById("cd-feedback");
      render(designId);
    },
    voteFor: function (designId) { return votes[designId] || 0; },
    reset: function () { votes = {}; persist(); }
  };
})();
